var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 81,
    viewBox: "0 0 57 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0164 8.48263L42.1969 8.06664C48.2209 15.7339 41.1713 37.1114 41.1713 37.1114L40.5822 38.5376C41.8447 38.8006 42.6501 38.8091 42.784 38.5005L42.7883 38.4338L42.809 38.4428C45.8853 31.3254 47.7198 22.9942 47.7198 22.9942C49.9187 7.72957 43.7939 5.62828 43.7939 5.62828L43.788 5.62572C43.6151 5.52677 43.4383 5.43444 43.2555 5.35515C42.1401 4.87126 40.9011 4.80473 39.5925 5.09548C29.9407 6.8674 20.7173 27.4795 20.2062 28.637L20.2263 28.6457L20.1811 28.6947C19.8147 29.5393 24.577 32.421 30.8171 35.1282C33.5133 36.2978 36.0415 37.2416 38.0757 37.8709C47.0041 13.8105 42.0164 8.48263 42.0164 8.48263Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0713 72.7601C23.3149 76.3364 26.7278 75.5108 26.7278 75.5108L42.5234 39.1011C42.5234 39.1011 42.096 39.4431 40.3183 39.1738L26.0741 73.532L23.0326 72.7738L37.4399 39.5642C37.5692 39.2309 37.6849 38.9144 37.8086 38.5879C36.3799 38.1706 34.5409 37.5156 32.1689 36.5057C32.1689 36.5057 21.7741 32.4684 19.799 29.5755L4.12496 65.705C4.5948 67.2903 6.82798 69.1839 15.0713 72.7601Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5738 77.9234C26.435 78.2105 27.2674 78.0407 27.6161 77.713L27.6707 77.6579C27.8031 77.5026 27.8606 77.3216 27.9692 77.1359C28.0652 76.7793 27.9729 76.3974 27.5937 76.163L27.5502 76.1406C27.1674 76.032 26.7238 75.9938 26.5011 76.0331C26.5011 76.0331 23.3743 76.6904 16.7382 74.0241C10.0999 71.3547 6.60954 69.9304 3.89826 66.2273C3.89826 66.2273 3.25785 64.7919 2.48013 65.6121C1.70149 66.4344 3.92049 69.8168 7.75479 71.9031C11.5908 73.987 18.8307 77.4439 23.5738 77.9234Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5821 38.5373C39.8777 38.3925 39.0349 38.1674 38.0756 37.8706C37.989 38.1063 37.899 38.3475 37.8086 38.5874C38.8498 38.8917 39.6738 39.0748 40.3183 39.1732L40.5821 38.5373Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0164 8.48263L42.1969 8.06664C48.2209 15.7339 41.1713 37.1114 41.1713 37.1114L40.5822 38.5376C41.8447 38.8006 42.6501 38.8091 42.784 38.5005L42.7883 38.4338L42.809 38.4428C45.8853 31.3254 47.7198 22.9942 47.7198 22.9942C49.9187 7.72957 43.7939 5.62828 43.7939 5.62828L43.788 5.62572C43.6151 5.52677 43.4383 5.43444 43.2555 5.35515C42.1401 4.87126 40.9011 4.80473 39.5925 5.09548C29.9407 6.8674 20.7173 27.4795 20.2062 28.637L20.2263 28.6457L20.1811 28.6947C19.8147 29.5393 24.577 32.421 30.8171 35.1282C33.5133 36.2978 36.0415 37.2416 38.0757 37.8709C47.0041 13.8105 42.0164 8.48263 42.0164 8.48263Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0713 72.7601C23.3149 76.3364 26.7278 75.5108 26.7278 75.5108L42.5234 39.1011C42.5234 39.1011 42.096 39.4431 40.3183 39.1738L26.0741 73.532L23.0326 72.7738L37.4399 39.5642C37.5692 39.2309 37.6849 38.9144 37.8086 38.5879C36.3799 38.1706 34.5409 37.5156 32.1689 36.5057C32.1689 36.5057 21.7741 32.4684 19.799 29.5755L4.12496 65.705C4.5948 67.2903 6.82798 69.1839 15.0713 72.7601Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5738 77.9234C26.435 78.2105 27.2674 78.0407 27.6161 77.713L27.6707 77.6579C27.8031 77.5026 27.8606 77.3216 27.9692 77.1359C28.0652 76.7793 27.9729 76.3974 27.5937 76.163L27.5502 76.1406C27.1674 76.032 26.7238 75.9938 26.5011 76.0331C26.5011 76.0331 23.3743 76.6904 16.7382 74.0241C10.0999 71.3547 6.60954 69.9304 3.89826 66.2273C3.89826 66.2273 3.25785 64.7919 2.48013 65.6121C1.70149 66.4344 3.92049 69.8168 7.75479 71.9031C11.5908 73.987 18.8307 77.4439 23.5738 77.9234Z",
    fill: "url(#paint6_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5821 38.5373C39.8777 38.3925 39.0349 38.1674 38.0756 37.8706C37.989 38.1063 37.899 38.3475 37.8086 38.5874C38.8498 38.8917 39.6738 39.0748 40.3183 39.1732L40.5821 38.5373Z",
    fill: "url(#paint7_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 46.1144,
    y1: 24.18,
    x2: 13.7538,
    y2: 10.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 31.7789,
    y1: 57.2241,
    x2: -0.581723,
    y2: 43.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 24.6835,
    y1: 77.1594,
    x2: -12.0926,
    y2: 61.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 40.1099,
    y1: 38.9591,
    x2: 36.7266,
    y2: 37.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 46.1144,
    y1: 24.18,
    x2: 13.7538,
    y2: 10.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 31.7789,
    y1: 57.2241,
    x2: -0.581723,
    y2: 43.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 24.6835,
    y1: 77.1594,
    x2: -12.0926,
    y2: 61.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 40.1099,
    y1: 38.9591,
    x2: 36.7266,
    y2: 37.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818D37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShot);
export default __webpack_public_path__ + "static/media/shot.dd183e2f21d33c46a7db9539b8f45ef2.svg";
export { ForwardRef as ReactComponent };